var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCappuccino(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 288 288",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#765638;stroke-linejoin:round;stroke-width:6px;fill:url(#capuccino);}.cls-2{fill:none;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "capuccino",
    x1: 138.5,
    y1: 188,
    x2: 138.5,
    y2: 107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c69c6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#c79e70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#cba57a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#d1b08a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#dbc0a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#e6d4c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#f5ede4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98,107c.68,4,1.41,8,2.17,12-3.9-2.06-8.68-3.61-13.58-2.82-3.88.63-9.34,3-13.24,10.83-3.59,7.18-3,15.2,1.51,22.58,6.83,11,22.79,20.17,36.66,21.27q2.19,8.72,4.48,17.11h72q4.71-17.28,9-36c3.54-15.55,6.51-30.58,9-45ZM84.22,143.83c-2.59-4.19-2.93-8.07-1-11.87,2.2-4.4,4.42-4.77,5.15-4.89a6.24,6.24,0,0,1,1-.07c3.86,0,8.6,3.35,11,5.43L107,159C97.91,156.68,88.39,150.58,84.22,143.83Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 288,
    height: 288
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCappuccino);
export default __webpack_public_path__ + "static/media/cappuccino.5882a8489f9b15c0fa34337f8e09302b.svg";
export { ForwardRef as ReactComponent };